export const baseUrl = () => {
    if (window.location.host === 'localhost:3000') {
        return "https://ctpapi.theretailinsightsdemos.com/"
    } 
    else if (window.location.host == 'ctpv2.theretailinsightsdemos.com') {
        return "https://ctpapi.theretailinsightsdemos.com/"
    } 
    else if (window.location.host == 'ctp.roycetoo.com') {
        return "https://ctpapi.roycetoo.com/"
    } 
    else {
         return "/"
    }
}

// Users allowed to use "Download Sample Setup Sheet" in SR screens
const sampleSetupSheetUsers = [
    'jgarcia@roycetoo.com',
    'lmoreno@roycetoo.com',
    'dmiller@roycetoo.com',
    

]

export const canDownloadSampleSetupSheet = (graphData) => {
    const email = (graphData?.mail || graphData?.userPrincipalName || '').toLowerCase()
    return sampleSetupSheetUsers.includes(email)
}
